<template>
  <div class="rich-block roll-block" v-bind:class="{ 'is-show': isActive }">
    <div :class="'roll-block__wrapper ' + className">
      <slot name="content"></slot>
    </div>
    <div class="roll-block__button py-8 text-center">
      <div
        class="btn border-radius-md fs-14"
        @click="toggleState()"
        :style="
          'background-color:' +
          getSelectedProduct.richButtonColorBg +
          ';color:' +
          getSelectedProduct.richButtonColorText
        "
      >
        <span class="d-block">
          <slot name="text-button-active" v-if="isActive"></slot>
          <slot name="text-button" v-else></slot>
        </span>
        <Icon
          iconName="icon-chevron-down"
          className="ml-8 icon-16 active-rotate-180"
          v-bind:class="{ 'is-active': isActive }"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Icon from "../Icon/Icon.vue";
import { useProductStore } from "@/pages/product_card/stores/store_catalog";
import { mapState } from "pinia";
export default {
  name: "RollBlockRich",
  components: {
    Icon,
  },
  computed: {
    ...mapState(useProductStore, ["getSelectedProduct"]),
  },
  props: {
    className: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      isActive: false,
    };
  },
  methods: {
    toggleState() {
      this.isActive = !this.isActive;
    },
  },
};
</script>

<style lang="scss">
@import "./roll-block.scss";
@import "./rich-block.scss";
</style>
